module.exports = __webpack_public_path__ + "static/img/img_so_falta_sua_empresa.2c0d886.png";


//////////////////
// WEBPACK FOOTER
// ./static/hotpages/promo-so-falta-sua-empresa/img_so_falta_sua_empresa.png
// module id = 1847
// module chunks = 1